import { ExpiredLinkErrorPage } from "pages/errors/expiredLink";
import { ExpiredErrorTypes } from "pages/errors/expiredLink/constants";

export const ExpiredLoginLink = () => {
    return <ExpiredLinkErrorPage type={ExpiredErrorTypes.Login} />;
};
